var _g, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInstallPwa = function SvgInstallPwa(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 200,
    height: 200,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 200 200",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.447
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.49 125.28 5.569-14.082h16.079l-7.632-21.361 9.544-24.133 27.334 72.577h-20.158l-4.671-12.999zM128.3 134.3l29.262-72.577-19.4.002-20.017 46.9-14.235-46.9H89l-15.284 46.9-10.779-21.373-9.754 30.052 9.904 16.995h19.092l13.812-42.06 13.167 42.06zM22.032 109.4h11.949c3.62 0 6.843-.403 9.67-1.212l3.09-9.52 8.636-26.608a21.151 21.151 0 0 0-2.253-2.959C48.689 64.192 42.2 61.74 33.659 61.74H3.617v72.577H22.03zm15.816-30.965c1.733 1.744 2.598 4.077 2.598 6.999 0 2.946-.762 5.281-2.284 7.007-1.671 1.918-4.745 2.878-9.224 2.878h-6.906V75.821h6.957c4.174 0 7.128.87 8.86 2.614z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.78 150.21v27.57H22.22v-27.57H-.002v27.57c0 12.273 9.95 22.222 22.222 22.222h155.56c12.273 0 22.222-9.95 22.222-22.222v-27.57zM100 44.954l28.484-33.274h-19.653V0H91.17v11.68H71.517z"
  })));
};
export default SvgInstallPwa;